import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NowaccountSharedModule } from 'src/app/shared/nowaccount/nowaccount-shared.module';
import { ClientRoutingModule } from './client-routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';

const components = [DashboardComponent];

const modules = [CommonModule, ClientRoutingModule, NowaccountSharedModule];

@NgModule({
  declarations: [...components],
  imports: [...modules],
  exports: [...components, ...modules],
})
export class ClientModule {}
